/**
 * Shared container object that is filled depending on the current user/role combination to display the correct
 * information in the now permanent visible dashboard-info-box.component
 */
import { Datenabfrage } from './datenabfrage/datenabfrage';
import { NetzzuordnungenImportSnapshot } from './netzzuordnungen-import-snapshot.model';

export class DashboardInfoContainer {

    lastConfirmedUuidDate: Date; // uuid-change

    erzeugungsAnlageLastUpdateDate: Date; // erzeugungsanlage-lastupdate

    numberOfDeleteNetzzuordnung: number;

    netzbetreiberLastUpdate: Date;

    isErzeugungsanlageLastChangedAndNetzbeteiberLastUpdateToOld: boolean;

    erzeugungsAnlagenCount: number; // for nvnb: his values, for wn-user: all

    netzzuordnungCount: number; // for nvnb: his values, for wn-user: all

    numberOfUncofirmedNetzzuordnungUUIDs: number;

    toOldNetzbetreibersCsv: string[];

    aktiveDatenAbfrage: Datenabfrage;

    isUserAssignedToAktiveDatenabfrage: boolean;

    aufteilungsschluesselCount: number; // for admin

    aufteilungsSchluesselSubmitted: boolean; // for nvnb

    isErzeugungsAnlagenPflegeAktiv: boolean; // for nvnb

    netzzuordnungImport: NetzzuordnungenImportSnapshot | null | undefined; // for admin
}
